import validate from "/app/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_1154bcf68ac1f6b921112be513bfcfcb/node_modules/nuxt/dist/pages/runtime/validate.js";
import sa_45host_45global from "/app/apps/nuxt/app/middleware/sa-host.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.29.7_@babel+core@7.29.7__@babel+plugin-syntax-typ_1154bcf68ac1f6b921112be513bfcfcb/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  sa_45host_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "commitment-step": () => import("/app/apps/nuxt/app/middleware/commitment-step.ts")
}